import _createForOfIteratorHelper from "/Users/developer05/project/wiseberry_sass_frontEnd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/Users/developer05/project/wiseberry_sass_frontEnd/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { JOSENotSupported } from '../util/errors.js';
function validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
  if (joseHeader.crit !== undefined && protectedHeader.crit === undefined) {
    throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
  }
  if (!protectedHeader || protectedHeader.crit === undefined) {
    return new Set();
  }
  if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some(function (input) {
    return typeof input !== 'string' || input.length === 0;
  })) {
    throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  }
  var recognized;
  if (recognizedOption !== undefined) {
    recognized = new Map([].concat(_toConsumableArray(Object.entries(recognizedOption)), _toConsumableArray(recognizedDefault.entries())));
  } else {
    recognized = recognizedDefault;
  }
  var _iterator = _createForOfIteratorHelper(protectedHeader.crit),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var parameter = _step.value;
      if (!recognized.has(parameter)) {
        throw new JOSENotSupported("Extension Header Parameter \"".concat(parameter, "\" is not recognized"));
      }
      if (joseHeader[parameter] === undefined) {
        throw new Err("Extension Header Parameter \"".concat(parameter, "\" is missing"));
      } else if (recognized.get(parameter) && protectedHeader[parameter] === undefined) {
        throw new Err("Extension Header Parameter \"".concat(parameter, "\" MUST be integrity protected"));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return new Set(protectedHeader.crit);
}
export default validateCrit;